import {
  Box,
  Button,
  Heading,
  Text,
  useToast // 1. Importar o useToast
} from '@chakra-ui/react';
import { Layout, Logo } from 'components/atoms';
import React from 'react';
import { Link as LinkRouter } from 'react-router-dom';

const Biometria: React.FC = () => {
  const toast = useToast(); // 2. Inicializar o hook do toast

  const handleConnectCertificate = () => {
    // 3. Chamar o toast com a mensagem especificada
    toast({
      title: 'Plugin de Biometria não encontrado!',
      description: (
        <Box>
          <Text>Verifique se o seu plugin de biometria facial está corretamente instalado.</Text>
        </Box>
      ),
      status: 'error',
      duration: 9000, // Aumenta o tempo que o toast fica na tela
      isClosable: true,
      position: 'bottom-left' // Padrão do seu projeto
    });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      color="blackAlpha.900"
      bgColor="backdrop"
      h="100vh"
      w="100%"
    >
      <Box display="grid" w="100%" maxW="lg" gap={8}>
        <Box>
          <Logo maxW={187} />
        </Box>
        <Box
          bg="white"
          borderRadius="lg"
          px={{ base: 6, md: 12 }}
          py={{ base: 8, md: 12 }}
        >
          <Heading size="md" textAlign="center" mb={2}>
            Acesso com Biometria Facial
          </Heading>

          <Layout type="container" full px={6} mt={10}>
            <Layout type="row" gutter={{ y: 1.5 }}>
              <Layout type="col" layout={{ base: 12 }}>
                <Button
                  w="full"
                  colorScheme="primary"
                  size="md"
                  onClick={handleConnectCertificate}
                >
                   Realizar Biometria Facial
                </Button>
              </Layout>
              <Layout type="col" layout={{ base: 12 }}>
                <Button
                  as={LinkRouter}
                  to="/entrar"
                  size="md"
                  w="full"
                  colorScheme="primary"
                  variant="link"
                  textDecoration="underline"
                >
                  Voltar
                </Button>
              </Layout>
            </Layout>
          </Layout>
        </Box>
      </Box>
    </Box>
  );
};

export default Biometria;